<script lang="typescript">
  import type { EditFormValues } from "./types";
  export let values: EditFormValues = { for_sale: true };
  export let saving: boolean = false;
  $: disabled = saving;
</script>

<form on:submit|preventDefault>
  <p class="form-row">
    <label for="type">Tunniste</label>
    <input
      bind:value={values.type}
      class="full"
      name="type"
      id="type"
      type="text"
      required
    />
  </p>
  <p class="form-row">
    <label for="name">Nimi</label>
    <input
      bind:value={values.name}
      class="full"
      name="name"
      id="name"
      type="text"
      required
    />
  </p>
  <p class="form-row">
    <label for="default-title">Oletusotsikko</label>
    <input
      class="full"
      bind:value={values.default_title}
      name="default-title"
      id="default-title"
      type="text"
    />
  </p>
  <p class="form-row">
    <label for="default-description">Oletuskuvaus</label>
    <textarea
      class="full"
      rows="6"
      bind:value={values.default_description}
      name="default-description"
      id="default-description"
    />
  </p>
  <p class="form-row">
    <label for="seats">Paikkojen lukumäärä</label>
    <input
      bind:value={values.seats}
      name="seats"
      id="seats"
      type="number"
      required
    />
  </p>
  <p class="form-row">
    <label for="required_seats">Osallistujamäärä jotta järjestetään</label>
    <input
      bind:value={values.required_seats}
      name="required_seats"
      id="required_seats"
      type="number"
      required
    />
  </p>
  <p class="form-row">
    <label for="price">Hinta</label>
    <input
      bind:value={values.price}
      name="price"
      id="price"
      type="number"
      required
    />
  </p>
  <p class="form-row">
    <label for="duration">Kesto minuuteissa</label>
    <input
      bind:value={values.duration_in_minutes}
      name="duration"
      id="duration"
      type="number"
      class="full"
      required
    />
  </p>
  <p class="form-row">
    <label for="for-sale">Myynnissä asiakkaalle</label>
    <input
      bind:checked={values.for_sale}
      name="for-sale"
      id="for-sale"
      type="checkbox"
    />
  </p>
  <p class="form-row">
    <label for="submit">&nbsp;</label>
    <input
      name="submit"
      id="submit"
      type="submit"
      value="Tallenna"
      {disabled}
    />
  </p>
  {#if saving}
    <p>
      <i class="fas fa-spinner fa-spin fa-lg" /> Tallennetaan...
    </p>
  {/if}
</form>

<style>
  form {
    margin-bottom: 36px;
  }
  .form-row {
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
  }
  label {
    display: inline;
    width: 180px;
    text-align: right;
    padding-right: 20px;
    margin-top: 8px;
  }
  .full {
    flex: 1;
    width: 100%;
  }
  textarea {
    border: 1px solid #999999;
    width: 98%;
    margin: 5px 0;
    padding: 1%;
  }
</style>
